/*
	© 2016 NetSuite Inc.
	User may not copy, modify, distribute, or re-bundle or otherwise make available this code;
	provided, however, if you are an authorized user with a NetSuite account or log-in, you
	may use this code subject to the terms that govern your access and use.
*/

// @module Cart
define('C3.ShoppingExtensions.ViewInventory.Router'
,	[	

		'C3.ShoppingExtensions.ViewInventory.Collection'
	,    'C3.ShoppingExtensions.ViewInventory.View'
	,	'jQuery'
	,	'Backbone'
	,   'Utils'
	]
,	function (

		ViewInventoryCollection
	,   ViewInventoryView
	,	jQuery
	,	Backbone
	,   Utils
	)
{
	'use strict';

	// @class Cart.Router responsible to know render the cart when the user navigates to the cart url @extends Backbone.Router
	return Backbone.Router.extend({

		routes: {
			'inventory-page': 'getViewInventoryPage'	
		,	'inventory-page?:options': 'getViewInventoryPage'
		}

	,	initialize: function (application)
		{
			this.application = application;
			//this.profileModel = ProfileModel.getInstance();
		}

	,   getViewInventoryPage: function(options)
		{
			//console.log(options)
			options = (options) ? Utils.parseUrlOptions(options) : {page: 1};
			options.page = options.page || 1;

			var collection = new ViewInventoryCollection();

			var app = this.application;

			var Configuration = app.Configuration;
			var savedsearchConfiguration = Configuration.PDPInventorySavedSearches
			,   savedsearchConfigurationConfig = savedsearchConfiguration.config
			//console.log(savedsearchConfigurationConfig)

			var findProductGroup = _.findWhere(savedsearchConfigurationConfig, {
                    productgroup: options.group
                });

			//console.log(findProductGroup)
			
			var ieView = new ViewInventoryView({
				    application: this.application
				,   collection : collection				
				,   pageNumber: options.page
				,   group : options.group
				,   searchid : findProductGroup.savedsearchid
				});
			ieView.showContent();

			/*collection.fetch({ data:{				
				pageNumber: options.page,
				resultsPerPage: 50,
				searchid : findProductGroup.savedsearchid,
				filters: ''
			} }).done(function() { ieView.showContent(); });*/
		
			
		}	
	});
});
